
export default {
  name: 'TheFooter',
}
